import { HttpBackend, HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { lastValueFrom } from 'rxjs'
import { PlatformSettings } from '@app/shared/models/platform-settings.model'
import { environment } from '@environments/environment'
import { domainName, subdomainByEnv } from '../helpers/domain-name'

@Injectable({
  providedIn: 'root',
})
export class InititializerService {
  platformSettings: PlatformSettings

  constructor(private httpBackend: HttpBackend) {}

  async getPlatformSettings() {
    const httpClient = new HttpClient(this.httpBackend)
    const protocol = 'https'
    const isProduction = () => {
      return process.env.NODE_ENV !== 'development'
    }
    const _host = isProduction() ? domainName() : domainName(environment.url)
    const apiSubdomain = subdomainByEnv('apiSubdomain')

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.platformSettings = (await lastValueFrom(
      httpClient.get(`${protocol}://${apiSubdomain}${_host}/api/platform-settings/domain`, { params: { domain: _host } }),
    )) as PlatformSettings
  }
}
